import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { getDateTime } from '../../../utils/time';
import { VISIT_TYPE, NOT_AVAILABLE } from '../../../constants/patientChart.constant';

export const OrderHeading = ({
  orderId = '',
  orderDate = '',
  scheduledVisit = '',
  visitType = '',
  loading = false
}) => {
  const { formatted: { date, time } } = getDateTime({ date_UTC: scheduledVisit });

  const OrderDate = new Map([
    [true, <Skeleton variant='text' width={140} />],
    [false, <span className='bold'>{orderDate || NOT_AVAILABLE}</span>]
  ]);

  const ScheduledOrAsyncVisit = new Map([
    [true, (
      <>
        <label className='m-r-2'>Scheduled Visit:</label>
        <span className='bold'>{`${time} - ${date}`}</span>
      </>
    )],
    [false, <span className='bold'>{VISIT_TYPE.ASYNC}</span>],
  ]);

  const ScheduledVisitDate = new Map([
    [true, (
      <>
        <label className='m-r-2'>Scheduled Visit:</label>
        <Skeleton variant='text' width={100} />
      </>
    )],
    [false, ScheduledOrAsyncVisit.get(visitType === VISIT_TYPE.SCHEDULED)]
  ]);

  return (
    <div className='patient-chart-order-heading height-40 flex align-items-center justify-content-space-between p-l-6 p-r-6'>
      <div className='order-id flex'>
        <label className='m-r-2'>Order ID:</label>
        <span className='bold'>{orderId}</span>
      </div>
  
      <div className='order-date flex'>
        <label className='m-r-2'>Order Date:</label>
        {OrderDate.get(loading)}
      </div>
  
      <div className='scheduled-visit-date flex'>
        {ScheduledVisitDate.get(loading)}
      </div>
    </div>
  );
};

export default OrderHeading;
